import styled from 'styled-components';
import {desktopMedia} from '../../../../globalVariables/GlobalVariables';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';
import {lightIsland} from '../../eTicketTheme.css';

export const panel = styled.div`
    ${lightIsland}
    width: 100%;
    max-width: none;
    max-height: 90vh;
    ${dFlexColumn};
    background: var(--color-bg-base);
    color: var(--color-text-default);
    border-radius: var(--border-radius-border-radius-2xl) var(--border-radius-border-radius-2xl) 0 0;
    padding-block: var(--space-md) max(var(--space-lg), env(safe-area-inset-bottom));
    overflow: hidden;

    ${desktopMedia} {
        width: 430px;
        border-radius: var(--border-radius-border-radius-xl);
    }
`;

export const handle = styled.div`
    flex: none;
    width: 36px;
    height: 4px;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--color-text-subtle);
    margin: 0 auto var(--space-xs);

    ${desktopMedia} {
        display: none;
    }
`;

export const title = styled.span`
    flex: none;
    padding-inline: var(--space-xl);
    margin-block: var(--space-xl);
    font-size: var(--font-size-heading-modal);
    font-weight: var(--font-weight-bold);
`;

export const footer = styled.div`
    flex: none;
    padding: var(--space-md) var(--space-xl) 0;

    & button {
        width: 100%;
    }
`;
